import httpService from '../core/services/HttpService';

interface PendingCounts {
  absenceRequests: number;
  total: number;
}

async function fetchPendingCounts(): Promise<PendingCounts> {
  try {
    const response = await httpService.get<any[]>('/api/absences/');
    const absenceRequests = response.data.filter(
      (item: any) => item.status === 'REQUESTED'
    ).length;
    return { absenceRequests, total: absenceRequests };
  } catch {
    return { absenceRequests: 0, total: 0 };
  }
}

const NotificationService = { fetchPendingCounts };
export default NotificationService;
export type { PendingCounts };
